/* eslint-disable no-nested-ternary */
import { AppContextType } from '../../store/AppContext';
import {
  AuthContextType,
  ErrorArgsType,
  InfoUsuarioOro,
} from '../../types/Types';
import { TarjetasOroConstants } from './TarjetasOroConstants';

/* eslint-disable import/prefer-default-export */
export class TarjetaOroHelper {
  static areConditionsAccepted = () => {
    let answer: boolean;
    const titularCuentaCheck = document.getElementById(
      'titular-cuenta',
    ) as HTMLInputElement;
    const aceptarLegalCheck = document.getElementById(
      'aceptar-legal',
    ) as HTMLInputElement;
    const errorSpan = document.getElementById(
      'error-checks',
    ) as HTMLSpanElement;
    if (titularCuentaCheck.checked && aceptarLegalCheck.checked) {
      errorSpan.classList.add('hide');
      answer = true;
    } else {
      errorSpan.classList.remove('hide');
      answer = false;
    }
    return answer;
  };

  static hideErrorWhenChecked = () => {
    const titularCuentaCheck = document.getElementById(
      'titular-cuenta',
    ) as HTMLInputElement;
    const aceptarLegalCheck = document.getElementById(
      'aceptar-legal',
    ) as HTMLInputElement;
    const errorSpan = document.getElementById(
      'error-checks',
    ) as HTMLSpanElement;
    if (titularCuentaCheck.checked && aceptarLegalCheck.checked) {
      errorSpan.classList.add('hide');
    }
  };

  static selectCuota = (cuota: number) => {
    const select4Link = document.getElementById(
      'selected-4',
    ) as HTMLLinkElement;
    const select6Link = document.getElementById(
      'selected-6',
    ) as HTMLLinkElement;
    const result4 = document.getElementById('result-4') as HTMLDivElement;
    const result6 = document.getElementById('result-6') as HTMLDivElement;
    if (cuota === 4) {
      select4Link.classList.add('active');
      result4.classList.add('active');
      select6Link.classList.remove('active');
      result6.classList.remove('active');
    }
    if (cuota === 6) {
      select6Link.classList.add('active');
      result6.classList.add('active');
      select4Link.classList.remove('active');
      result4.classList.remove('active');
    }
  };

  static resetForm = (formId: string) => {
    const form = document.getElementById(formId) as HTMLFormElement;
    if (form) {
      form.reset();
    }
    if (TarjetasOroConstants.FORM_ORO === formId) {
      const selectPais = document.getElementById(
        'country-fact',
      ) as HTMLSelectElement;
      if (selectPais) {
        selectPais.value = TarjetasOroConstants.ID_ESPAÑA_STR;
      }
    }
    document.body.classList.remove('fix');
  };

  static bindResetToBack = (reset: any) => {
    const linkBack = document.getElementById('link-back') as HTMLLinkElement;
    if (linkBack !== null) {
      linkBack.onclick = reset;
    }
  };

  static calculateSaving = (quantity: number, percent: string) => {
    let percentNumber = 4;
    let cuote = TarjetasOroConstants.CUOTA_BAJA;
    if (percent === TarjetasOroConstants.CUATRO_POR_CIENTO) {
      percentNumber = 4;
      cuote = TarjetasOroConstants.CUOTA_BAJA;
    }
    if (percent === TarjetasOroConstants.SEIS_POR_CIENTO) {
      percentNumber = 6;
      cuote = TarjetasOroConstants.CUOTA_ALTA;
    }
    return quantity * 12 * (percentNumber / 100) - cuote * 12;
  };

  static hideResultadoCalculadora = () => {
    const result = document?.getElementsByClassName(
      'calculadora-resultado',
    )[0] as HTMLDivElement;
    if (!result.classList.contains('hide')) {
      result.classList.add('hide');
    }
  };

  static showResultadoCalculadora = () => {
    const result = document?.getElementsByClassName(
      'calculadora-resultado',
    )[0] as HTMLDivElement;
    result.classList.remove('hide');
  };

  static getSavingCalculated = (isCuotaAlta: boolean) => {
    const input = document.getElementById('gasto') as HTMLInputElement;
    // eslint-disable-next-line prettier/prettier
    const quantity = (input.value as unknown) as number;
    const percent = !isCuotaAlta
      ? TarjetasOroConstants.CUATRO_POR_CIENTO
      : TarjetasOroConstants.SEIS_POR_CIENTO;
    return TarjetaOroHelper.calculateSaving(quantity, percent);
  };

  static getShowCambiarCuota = (infoUsuarioOro: InfoUsuarioOro) => {
    if (infoUsuarioOro) {
      const { estadoInt } = infoUsuarioOro;
      const { isBajaSolicitada } = infoUsuarioOro;
      const { isEmpresaOro } = infoUsuarioOro;

      if (estadoInt === 30 || isBajaSolicitada || isEmpresaOro) {
        return false;
      }
    }
    return true;
  };

  static getTipoCuotaAndValue = (
    infoUsuarioOro: InfoUsuarioOro | undefined,
    priceFormatter: any,
    t: any,
  ) => {
    const cuantiaCuota =
      infoUsuarioOro && infoUsuarioOro.cuantiaCuota
        ? infoUsuarioOro.cuantiaCuota
        : null;
    const showCuantia = infoUsuarioOro?.showCuotaValue && cuantiaCuota !== null;

    return infoUsuarioOro?.tipoCuota === TarjetasOroConstants.TIPO_CUOTA_4
      ? showCuantia
        ? `${TarjetasOroConstants.CUATRO_POR_CIENTO} - ${priceFormatter(
            cuantiaCuota,
            true,
          )} ${t('tarjetas.tarjeta-oro-datos.month-fee')}`
        : `${TarjetasOroConstants.CUATRO_POR_CIENTO} `
      : showCuantia
      ? `${TarjetasOroConstants.SEIS_POR_CIENTO} - ${priceFormatter(
          cuantiaCuota,
          true,
        )} ${t('tarjetas.tarjeta-oro-datos.month-fee')}`
      : `${TarjetasOroConstants.SEIS_POR_CIENTO}`;
  };

  static getModalConfirmarAltaOkHtml = (
    t: any,
    dataUser: AuthContextType,
    dataApp: AppContextType,
    routerLoader: any,
  ) => {
    const message = t('tarjetas.tarjeta-oro-datos.alta-ok-text-1');
    const link = `<a href="${
      process.env.REACT_APP_API
    }/clienteLogado/getTK?fromUrl=${process.env.REACT_APP_SERVER_EROSKI_ES}${t(
      'link.condiciones-oro',
    )}&fromApp=${t('eroski_es')}" class="oro_link">${t(
      'tarjetas.tarjeta-oro-datos.condiciones-link',
    )}</a>`;

    let htmlText = message
      .replace('<mail>', dataUser.user.emailContacto)
      .replace('<condiciones_link>', link);
    const modificarMailText = t('tarjetas.tarjeta-oro-datos.change-mail-text');
    const urlMisDatos = routerLoader.LoadRouterByPath(
      'mis-datos',
      dataApp.lang,
    );
    const mailLink = `<a href="${urlMisDatos}" class="oro_link">${t(
      'tarjetas.tarjeta-oro-datos.change-mail-link',
    )}</a>`;
    const modificarMailHtml = modificarMailText.replace('<link>', mailLink);
    htmlText = htmlText.concat('<br>').concat(modificarMailHtml);
    return htmlText;
  };

  static getErrorByResponse = (error: any, t: any) => {
    let text = '';
    // eslint-disable-next-line no-unused-expressions
    error?.userMessage?.forEach((err: ErrorArgsType) => {
      if (err.key) {
        if (err.arguments) {
          text = `${text} ${t(err.key.split('.').join('-'), {
            key: err.arguments,
          })}`;
        } else {
          text = `${text} ${t(err.key.split('.').join('-'))}`;
        }
      }
    });

    return text;
  };
}
